var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJumpToPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43715 0.144799L6.54121 2.35294C6.58695 2.40121 6.61942 2.4535 6.63863 2.5098C6.65754 2.56611 6.66699 2.62645 6.66699 2.6908C6.66699 2.75515 6.65754 2.81549 6.63863 2.8718C6.61942 2.92811 6.58695 2.98039 6.54121 3.02866L4.42571 5.26094C4.34185 5.34942 4.23513 5.39576 4.10553 5.39994C3.97593 5.4038 3.8692 5.35747 3.78535 5.26094C3.69387 5.17245 3.64813 5.05983 3.64813 4.92308C3.64813 4.78633 3.69387 4.66968 3.78535 4.57315L5.11182 3.17346L0.915135 3.17345L0.915134 11.5173C0.915134 11.6541 0.871223 11.7688 0.783402 11.8615C0.695885 11.9538 0.587327 12 0.45773 12C0.328132 12 0.219575 11.9538 0.132058 11.8615C0.0442367 11.7688 0.00032571 11.6541 0.000325722 11.5173L0.000326494 2.6908C0.000326506 2.55405 0.0442375 2.4395 0.132059 2.34715C0.219576 2.25448 0.328133 2.20815 0.457731 2.20815L5.11182 2.20815L3.78535 0.820513C3.70149 0.732027 3.65773 0.6215 3.65407 0.48893C3.65011 0.35604 3.69387 0.24133 3.78535 0.144799C3.87683 0.0482681 3.98539 7.19241e-07 4.11102 7.30224e-07C4.23696 7.41234e-07 4.34567 0.0482681 4.43715 0.144799Z",
    fill: "#E92D71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.3335,
    y: 1.33333,
    width: 8,
    height: 1.33333,
    rx: 0.666667,
    fill: "#E92D71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.3335,
    y: 5.33333,
    width: 8,
    height: 1.33333,
    rx: 0.666667,
    fill: "#E92D71"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.3335,
    y: 8.66667,
    width: 8,
    height: 1.33333,
    rx: 0.666667,
    fill: "#E92D71"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpToPink);
export default __webpack_public_path__ + "static/media/jump_toPink.8feae7a1d087bb9d2eee968972cbb209.svg";
export { ForwardRef as ReactComponent };